import { omit } from 'lodash';

/**
 *  범위 : 유저 상세 페이지 > 팔로우한 태그 정보, 좋아요한 상품 정보, 좋아요한 브랜드 정보 탭
 *  기능 : 타임라인(로그) 리스트 가져올때 saga에서 설정하는 payload
 */
export const setTimelineRequestPayload = (data, historyPropName) => {
  return {
    ...omit(data, ['init']),
    [historyPropName]: {
      ...data[historyPropName],
      filterOption: {
        ...data[historyPropName].filterOption,
        actionLogType: data['init'] ? null : data[historyPropName].filterOption.actionLogType,
      },
    },
  };
};
